import { createFileRoute, Navigate } from '@tanstack/react-router';

import { getRunEnvironment } from '@apps/web/lib/runtime_config';
import { PhoebeThinkingTipsMockupPage } from '@apps/web/routes/phoebe_thinking_tips_mockup_page';

export const Route = createFileRoute('/phoebe-thinking-tips-mockup')({
    component: PhoebeThinkingTipsMockupRoute,
    head: () => ({
        meta: [
            {
                title: 'Phoebe thinking tips mockup | Phoebe',
            },
        ],
    }),
});

function PhoebeThinkingTipsMockupRoute() {
    if (getRunEnvironment() !== 'development') {
        return <Navigate to="/" replace={true} />;
    }

    return <PhoebeThinkingTipsMockupPage />;
}
